import '../../libs/tinymce/tinymce.min.js';
import '../../libs/tinymce/themes/modern/theme.min.js';
import '../../libs/tinymce/plugins/code/plugin.min.js';
import '../../libs/tinymce/plugins/advlist/plugin.min.js';
import '../../libs/tinymce/plugins/anchor/plugin.min.js';
import '../../libs/tinymce/plugins/autolink/plugin.min.js';
import '../../libs/tinymce/plugins/charmap/plugin.min.js';
import '../../libs/tinymce/plugins/contextmenu/plugin.min.js';
import '../../libs/tinymce/plugins/fullscreen/plugin.min.js';
import '../../libs/tinymce/plugins/hr/plugin.min.js';
import '../../libs/tinymce/plugins/image/plugin.min.js';
import '../../libs/tinymce/plugins/insertdatetime/plugin.min.js';
import '../../libs/tinymce/plugins/lists/plugin.min.js';
import '../../libs/tinymce/plugins/link/plugin.min.js';
import '../../libs/tinymce/plugins/autoresize/plugin.min.js';
import '../../libs/tinymce/plugins/media/plugin.min.js';
import '../../libs/tinymce/plugins/paste/plugin.min.js';
import '../../libs/tinymce/plugins/searchreplace/plugin.min.js';
import '../../libs/tinymce/plugins/spellchecker/plugin.min.js';
import '../../libs/tinymce/plugins/table/plugin.min.js';
import '../../libs/tinymce/plugins/textcolor/plugin.min.js';
import '../../libs/tinymce/plugins/textpattern/plugin.min.js';
import '../../libs/tinymce/plugins/colorpicker/plugin.min.js';
import '../../libs/tinymce/plugins/visualblocks/plugin.min.js';
import '../../libs/tinymce/plugins/fullpage/plugin.min.js';
import '../../libs/tinymce/plugins/mention/plugin.min.js';
import '../../libs/tinymce/plugins/wordcount/plugin.min.js';

export default tinymce;
